import type { Dispatch, AnyAction } from 'redux';

import * as FindForCompanyAPI from 'ab-api/web/materialCompanyMarkupHistory/findForCompany';
import * as UpsertAPI from 'ab-api/web/materialCompanyMarkupHistory/upsert';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function findForCompany() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindForCompanyAPI.W_MaterialCompanyMarkupHistory_FindForCompany_VM>(FindForCompanyAPI.URL());
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function upsert(data: UpsertAPI.W_MaterialCompanyMarkupHistory_Upsert_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<UpsertAPI.W_MaterialCompanyMarkupHistory_Upsert_VM>(UpsertAPI.URL(), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
